import { render } from "./IncidentManagement.vue?vue&type=template&id=14a9a1ed"
import script from "./IncidentManagement.vue?vue&type=script&lang=js"
export * from "./IncidentManagement.vue?vue&type=script&lang=js"

import "../assets/css/incident.css?vue&type=style&index=0&lang=css&external"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__